import React, { useRef } from "react";
import ReactPlayer from "react-player";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import { Icon, InlineIcon } from '@iconify/react';
//import { Link } from 'react-router-dom';
import Slider from "react-animated-slider";

import {
    Col,
    Container,
    Row,
    Image
} from 'react-bootstrap'

import './newsflash.css'

import CardMenu from '../../components/CardMenuSet/CardMenu' ;



const Newsflash = () => {

    const reactPlayerRef = useRef();

    return (
      
        <Container className="main"  fluid>
       
              

                          <h6  style={{ color: '#6A040F'}} className="font-weight-bold">
                          Vous aspirez à maîtriser rapidement un domaine spécifique pour être immédiatement opérationnel(le) ? </h6>

                          <br/> 
                          <br/>

                         <h6  style={{ color: '#D00000'}} className="font-weight-bold">Dans un court laps de temps , nos sessions de formation express vous offrent l'opportunité d'acquérir les compétences clés nécessaires à votre performance professionnelle.  </h6> 
                        
                        <br/> 
                        <br/>
            <CardMenu/>

           

        
        </Container>
    )
}

export default Newsflash
